import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import meeting from './meeting/meeting.js'
import buttons from './buttons/buttons.js'
import permission from './permission/permission.js'
import rte from './rte/rte.js'
import scrollToBottom from './scroll/scrollToBottom.js'
import dev_load from './dev_load.js'
import scroll from './scroll/scroll.js'
import hotkeys from './hotkeys/hotkeys.js'

export default contract({
  buttons: array([
    buttons
  ]),
  hotkeys,
  dev_load: array([
    dev_load
  ]),
  meeting: array([
    meeting
  ]),
  permission: array([
    permission
  ]),
  rte,
  scroll: array([
    scroll
  ]),
  scrollToBottom: array([
    scrollToBottom
  ]),
})
